const Controller = require("./dist/controller");
module.exports = Controller;